import { ArrowRight } from "lucide-react";
import { HeroBackground } from "./HeroBackground";
import { ACTIVITY_PAUSED, PAUSE_CTA_LABEL } from "../lib/constants";

function HeroPrimaryCta() {
    if (ACTIVITY_PAUSED) {
        return (
            <a
                href="#contact"
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 border border-slate-300 text-slate-600 bg-white/60 text-sm font-medium rounded-full hover:border-slate-400 hover:text-[#0B132B] transition-colors duration-200 whitespace-nowrap"
                data-testid="hero-cta-primary"
                aria-label="Activité en pause. En savoir plus."
            >
                {PAUSE_CTA_LABEL}
            </a>
        );
    }
    return (
        <a
            href="#contact"
            className="inline-flex items-center justify-center gap-2 px-6 py-3.5 bg-[#0B132B] text-[#F9F9F8] text-sm font-medium rounded-full hover:bg-[#1B4332] transition-colors duration-200 whitespace-nowrap"
            data-testid="hero-cta-primary"
        >
            Me contacter
            <ArrowRight className="w-4 h-4" />
        </a>
    );
}

export function Hero() {
    return (
        <section
            id="top"
            className="relative overflow-hidden border-b border-slate-200"
            data-testid="hero-section"
        >
            <HeroBackground />

            <div className="relative z-10 mx-auto max-w-7xl px-6 md:px-12 lg:px-16 pt-14 md:pt-28 lg:pt-32 pb-14 md:pb-24">
                <p
                    className="reveal text-xs tracking-[0.18em] uppercase text-slate-500 mb-6 md:mb-8"
                    data-testid="hero-eyebrow"
                >
                    Données personnelles · Pratiques numériques · Conformité
                    réglementaire
                </p>

                <h1
                    className="reveal font-display text-[2rem] sm:text-4xl lg:text-[3.5rem] xl:text-[4rem] tracking-tight text-[#0B132B] font-medium max-w-4xl [text-wrap:balance]"
                    style={{ lineHeight: 1.12 }}
                    data-testid="hero-title"
                >
                    Sécuriser vos données, vos pratiques et vos obligations.
                </h1>

                <div className="mt-8 md:mt-12 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16">
                    <div className="lg:col-span-7">
                        <p
                            className="reveal text-base lg:text-lg text-slate-600 leading-relaxed max-w-xl"
                            data-testid="hero-subtitle"
                        >
                            J'aide les dirigeants, indépendants et structures
                            patrimoniales à repérer les points qui les
                            exposent, corriger leurs pratiques numériques et
                            sécuriser leurs obligations réglementaires
                            courantes.
                        </p>
                        <div
                            className="reveal mt-7 md:mt-9 flex flex-col sm:flex-row gap-3"
                            data-testid="hero-cta-group"
                        >
                            <HeroPrimaryCta />
                            <a
                                href="#perimetre"
                                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 border border-[#0B132B] text-[#0B132B] text-sm font-medium rounded-full hover:bg-[#0B132B] hover:text-[#F9F9F8] transition-colors duration-200 whitespace-nowrap"
                                data-testid="hero-cta-secondary"
                            >
                                Voir ce que je fais
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
